<script lang="ts" setup>
import { computed, onMounted } from "vue"; // Properties

// Properties
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: "",
  },
  initialError: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  roundedCorners: {
    type: Boolean,
    default: true,
  },
  roundSize: {
    type: String,
    default: "rounded-2xl",
  },
  height: {
    type: String,
    default: "h-9",
  },
});

// Data
const emit = defineEmits(["update:modelValue", "change", "blur"]);
let error = "";

// Functions
function validateInput(value: string) {
  error = "";
  if (props.required) {
    if (value.length <= 0) {
      error = "Field is required";
    }
  }
}

function onChange(event: any) {
  validateInput(event.target.value);
  emit("change", event.target.value, error);
}

function onBlur(event: any) {
  validateInput(event.target.value);
  emit("blur", event.target.value, error);
}

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    validateInput(value);
    return emit("update:modelValue", value);
  },
});

onMounted(() => {
  error = props.initialError;
});
</script>

<template>
  <div class="select-style" :class="(roundedCorners ? roundSize : '') + ' ' + height">
    <select v-model="model" :required="required" class="select-down-arrow" @change="onChange" @blur="onBlur">
      <slot></slot>
    </select>
  </div>
</template>

<style scoped>
.select-style {
  @apply relative inline-block border border border-gray-300 bg-white pl-4 pr-3 hover:border-gray-400;
}

.select-down-arrow {
  @apply h-full w-full bg-transparent bg-no-repeat focus:outline-none;
}
</style>
